document.addEventListener('DOMContentLoaded', function () {
  const SELECTOR = '.mm-toasty-presale .cards-slider';

  function parseBool(value) {
    return value === true || value === 'true';
  }

  function arrowMarkup(direction, index) {
    if (direction === 'prev') {
      return `<button type="button" class="slick-prev" role="button" aria-label="Previous" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="mm-toasty-prev-${index}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title id="mm-toasty-prev-${index}">Prev Item</title><polygon fill="currentColor" points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></svg><span hidden="hidden">Previous</span></button>`;
    }
    return `<button type="button" class="slick-next" role="button" aria-label="Next" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="mm-toasty-next-${index}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title id="mm-toasty-next-${index}">Next Item</title><polygon fill="currentColor" points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5"></polygon></svg><span hidden="hidden">Next</span></button>`;
  }

  function breakpoint() {
    const width = window.innerWidth;
    if (width <= 749) return 'mb';
    if (width <= 1000) return 'pad';
    return 'pc';
  }

  function applySlider(el) {
    const $el = $(el);
    if (!$el.length || typeof $.fn.slick !== 'function') return;

    const data = $el.data();
    const count = parseInt($el.attr('data-count'), 10) || 0;
    const bp = breakpoint();
    const slidesToShow = Number(
      bp === 'mb' ? data.slidestoshowMb : bp === 'pad' ? data.slidestoshowPad : data.slidestoshow
    ) || 1;
    const arrows = parseBool(bp === 'mb' ? data.arrowsMb : bp === 'pad' ? data.arrowsPad : data.arrows);
    const dots = parseBool(bp === 'mb' ? data.navigateMb : bp === 'pad' ? data.navigatePad : data.navigate);
    const needSlick = count > slidesToShow;
    const index = $el.attr('data-section-id') || '0';

    if ($el.hasClass('slick-initialized')) {
      $el.slick('unslick');
    }

    if (!needSlick) return;

    $el.slick({
      infinite: true,
      draggable: true,
      slidesToShow: slidesToShow,
      slidesToScroll: 1,
      autoplay: false,
      arrows: arrows,
      dots: dots,
      prevArrow: arrowMarkup('prev', index),
      nextArrow: arrowMarkup('next', index)
    });
  }

  function initAll(root) {
    const $scope = root ? $(root) : $(document);
    $scope.find(SELECTOR).each(function () {
      applySlider(this);
    });
  }

  let resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initAll();
    }, 150);
  }

  function start() {
    if (typeof $ === 'undefined') return;
    initAll();
    $(window).off('resize.mmToastyPresale').on('resize.mmToastyPresale', onResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (typeof $ === 'undefined') return;
    initAll(event.target);
  });
});